export default {
  getParentClientHeight() {
    let element = document.getElementById('content-container');
    if (element) {
      let clientHeight = element.clientHeight;
      if(clientHeight)
        return clientHeight;
    }
    return 635;
  }
}



// WEBPACK FOOTER //
// ./src/api/helpers/layout.js